export function isAccessDenied(
  userPermissions: readonly string[],
  permissionWhitelist?: readonly string[]
): boolean {
  const permissionIsRequired = (permissionWhitelist &&
    permissionWhitelist?.length > 0) as boolean

  const userIsMissingRequiredPermission =
    permissionIsRequired &&
    !permissionWhitelist?.some((p) => userPermissions.includes(p))

  return userIsMissingRequiredPermission
}
